import axios from "axios";
import Enco from "security/encrypt"
import Deco from "../security/decrypt"

const API_URL = `${process.env.REACT_APP_API_SERVER}/admin`;

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "/user/login", {
        username,
        password
      })
      .then(response => {
        if (response.data.token) {
          localStorage.setItem("user", Enco(JSON.stringify(response.data)));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
    window.location = "/admin/login"
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }

  getCurrentUserData() {
    return JSON.parse(Deco(localStorage.getItem('user')));
  }


}

export default new AuthService();
